import React from 'react';
// Global library
// Module library
import { LandingPageContainer } from './layouts/LandingPageContainer';

export const LandingPage = () => {
  return <LandingPageContainer />;
};
